import {MenuItem} from "@mui/material";
import {ImportingDataTypes} from "../../types";
import {importDeliveryModeSelectOptions, parseDeliveryModeTitleFromImport} from "../shared/import-delivery-mode";
import {createInvalidPartSection, PreventionInvalidityCode} from "./shared";

export const preventativeInteraction = {
    datasourceId: ImportingDataTypes.partDeliveryMode,
    sections: [
        createInvalidPartSection(),
        {
            sectionKey: 'invalidDeliveryMode',
            sectionTitle: 'Invalid Delivery Mode Values',
            invalidityCode: PreventionInvalidityCode.INVALID_DELIVERY_MODE,
            fields: [
                {
                    key: 'partNumber',
                    label: 'Part Number',
                    type: 'text',
                    extractValue: (o) => typeof o === 'string' ? o : o?.partNumber ?? null,
                    modifyRow: (row, val) => ({...row, partNumber: val}),
                },
                {
                    key: 'deliveryMode',
                    label: 'Delivery Mode',
                    type: 'input',
                    textFieldProps: {
                        select: true,
                        SelectProps: {
                            displayValue: (e) => typeof e === 'string' ? e : importDeliveryModeSelectOptions.find(o => o.value === e)?.label ?? "",
                        },
                        children: importDeliveryModeSelectOptions.map((e) => (
                            <MenuItem key={e.value} value={e.value}>
                                {e.label}
                            </MenuItem>
                        )),
                    },
                    extractValue: (o) => parseDeliveryModeTitleFromImport(o) ?? (typeof o === 'string' ? o : null),
                    modifyRow: (row, val) => ({...row, deliveryMode: val}),
                },
            ],
        },
    ],
};
